import { useCallback } from "react";
import { ServiceEnvironment } from "Enums/ServiceEnvironment";
import { CentralAdminEntityType } from "Enums/CentralAdminEntityType";
import { centralAdminForestSchema } from "Shared/Components/Scope/Topology/CentralAdminTopology";
import { ScopeItem } from "Shared/Components/Scope/Scopes.types";
import { useORPCClient } from "Core/oRPC";

export const useSubstrateForest = () => {
    const orpcClient = useORPCClient();

    const getForestList = useCallback(
        async (env?: ServiceEnvironment, workload?: string, selectedScopesSoFar?: ScopeItem[], isAccountForest: boolean = false): Promise<ScopeItem[]> => {
            const selectedRegion = selectedScopesSoFar?.find((scope) => scope.ScopeType?.toLowerCase() === "region");
            const skipRegionFilter = !selectedRegion || selectedRegion.Value?.toLowerCase() === "all";
            const forestRequest = {
                Environment: env,
                Workload: workload || "",
                TargetType: CentralAdminEntityType.Forest,
                FilterType: skipRegionFilter ? undefined : CentralAdminEntityType.Region,
                FilterValue: skipRegionFilter ? undefined : selectedRegion.Value?.toUpperCase()
            };
            const forestOut = await orpcClient.inventoryApi.postTopology(forestRequest);
            const forestParsedOutput = centralAdminForestSchema.array().parse(forestOut);
            const filtered = forestParsedOutput.filter((forest) =>
                isAccountForest ? forest.Type?.toLowerCase().includes("account") : !forest.Type?.toLowerCase().includes("account")
            );

            const list: ScopeItem[] = [];
            filtered.forEach((forest) => {
                if (forest.Name) {
                    const alias = forest.Alias ? forest.Alias.toUpperCase() : "";
                    const forestName = forest.Name.toUpperCase();
                    // If Forest name has alias then don't append alias.
                    const forestNameAlias = forestName.includes(alias) ? forestName : `${forestName} (${alias})`;
                    list.push({
                        ScopeType: isAccountForest ? "AccountForest" : "Forest",
                        Value: forestName,
                        ExtraProperties: { Alias: forestNameAlias, ShortAlias: alias, Region: forest.Region || "" }
                    });
                }
            });
            return list;
        },
        [orpcClient]
    );

    return {
        getForestList
    };
};
